// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".itemlist-enter-active,.itemlist-leave-active{opacity:1;transition:all .3s}.itemlist-enter,.itemlist-leave-to{opacity:0}", ""]);
// Exports
module.exports = exports;
